<script lang="ts">
export default {
  name: 'MenuIcon',
}
</script>

<template>
  <svg
    fill="none"
    height="18"
    viewBox="0 0 18 18"
    width="18"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="3.5" cy="3.5" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="9" cy="3.5" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="14.5" cy="3.5" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="3.5" cy="9" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="9" cy="9" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="14.5" cy="9" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="3.5" cy="14.5" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="9" cy="14.5" fill="#b0b0c0" r="1.8"></circle>
    <circle cx="14.5" cy="14.5" fill="#b0b0c0" r="1.8"></circle>
  </svg>
</template>

<style lang="scss" scoped></style>
